// extracted by mini-css-extract-plugin
module.exports = {"description":"DescriptionLegacy_description__LtfAb","descriptionTitle":"DescriptionLegacy_descriptionTitle__NR0Wg"};